define('datakit/hal/embedded.model',['require','exports','module','underscore','backbone','../model','backbone.radio'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Model = require('../model');
  var Radio = require('backbone.radio');

  var EmbeddedModel = Model.extend({

    onBeforeFirstSet: function(attrs, options) {
      Model.prototype.onBeforeFirstSet.apply(this, arguments);

      this.registerSetter(this.isNotChildModel, this.setUnkownEmbeddedResource);
      this.registerSerializer(this.serializeEmbeddedModels);
    },

    isNotChildModel: function(attr) {
      return !this.childModels[attr];
    },

    setUnkownEmbeddedResource: function(attr, value, options) {
      var HalModel = Radio.channel('models').request('DataKit.HalModel');
      this.setWithModelClass(attr, value, HalModel, options);
    },

    serializeEmbeddedModels: function(json, options) {
      _.each(json, function(model, key) {
        json[key] = (model && model.toJSON) ? model.toJSON(options) : model;
      });
    }

  });

  Radio.channel('models').reply('DataKit.EmbeddedModel', _.constant(EmbeddedModel));

  module.exports = EmbeddedModel;
});

